import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";

import {Button, Tooltip} from "@mui/material";
import Box from "@mui/material/Box";
import {UploadSignJobFileForm} from "./UploadSignJobFileForm";
import {useNavigate} from "react-router-dom";
import {Delete, Edit} from "@mui/icons-material";
import MaterialPriceUnitService from "../../../../../API/orders/warehouse/MaterialPriceUnitService";
import ModalConfirm from "../../../modal/ModalConfirm";

const SignJobTable = ({
                          data,
                          setData,
                          change,
                          setChange,
                          enableEditing,
                          uploadSignJob,
                          isRedirectSettings,
                          isChooseSignJob,
                          handleSubmitAddSign,
                          rowSelection,
                          setRowSelection,
                          rowIndexSelection,
                          setRowIndexSelection,
                          selectedIds,
                          setSelectedIds,
                          isPrice,
                          isUnit
                      }) => {


    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [currentEditRowId, setCurrentEditRowId] = useState(null);
    const [showConfirmAddSignJob, setShowConfirmAddSignJob] = useState(false);


    const navigate = useNavigate();

    const redirectSettings = () => {
        navigate('/settings-orders');
    };

    const handleUpdateModel = useCallback(
        (row) => {
            setCurrentEditRowData(row.original);
            setCurrentEditRowId(row.index);
            /* setUpdateModalOpen(true);*/
        },
        [data, currentEditRowData, setCurrentEditRowData],
    );

    const handleDeleteRow = useCallback(
        (row) => {
            const id = row.original.id;
            MaterialPriceUnitService.delete(id)
                .then(function () {
                    setData(prev => prev.filter(el => el.id !== id));
                    /* materialPriceUnits.delete(materialId);*/
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        [data],
    );

    const handleCloseShowConfirmAddSignJob = () => {
        setShowConfirmAddSignJob(false)
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: "signJob.name",
                header: 'Наименование операции',
                accessorKey: 'name',
                enableEditing: false,
                enableGrouping: true,
                minSize: 35,

            },
            {
                header: 'Трудоемкость в заказе',
                accessorKey: 'laborIntensity',
                enableColumnActions: false,
                enableEditing: false,
                minSize: 10,
                AggregatedCell: ({cell, table}) => (
                    <>
                        <Box sx={{
                            color: 'secondary.main',
                            fontWeight: 'bold'
                        }}>
                            {cell.getValue()?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </>
                ),
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
        ];

        if (isUnit) {
            baseColumns.splice(2, 0, {
                header: 'Ед.изм.',
                accessorKey: 'unit.name',
                enableColumnActions: false,
                enableEditing: false,
                size: 8,
            });
        }

        if (isPrice) {
            baseColumns.splice(4, 0, {
                header: 'Цена',
                accessorKey: 'jobPrice.price',
                enableColumnActions: false,
                enableEditing: false,
                size: 8,
                Cell: ({row}) => {
                    if (row.original.jobPrice !== undefined) {
                        return row.original.jobPrice.price + " " + row.original.jobPrice.currency.curAbbreviation;
                    }
                },
                AggregatedCell: ({cell, table}) => (
                    <>
                        <Box sx={{
                            color: 'secondary.main',
                            fontWeight: 'bold'
                        }}>
                            {cell.getValue()?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </>
                ),
            });
        }

        return baseColumns;

    }, [data, setData, isPrice, isUnit]);


    return (
        <div>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableBodyProps={{
                    sx: () => ({
                        '& tr:nth-of-type(odd)': {
                            backgroundColor: 'lightgray',
                        },
                    }),
                }}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        "&:after": {
                            display: "none",
                        },
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        muiTableHeadCellProps: {
                            align: 'center',
                        },
                        size: 15,
                        minSize: 15,
                    },
                }}
                columns={columns}
                data={data}
                rowHeight={13}
                columnSpacing={1}
                initialState={{
                    expanded: false,
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                    pagination: {pageIndex: 0, pageSize: 100},
                    sorting: [{id: 'signJob.name', desc: false}],
                }}
                // onRowSelectionChange={setRowSelection}
                state={{rowSelection}}
                enableRowSelection
                getRowId={(originalRow) => originalRow.id}
                localization={MRT_Localization_RU}
                enableEditing={enableEditing}
                renderRowActions={({row, table}) => (
                    <Box sx={{
                        display: 'flex',
                        gap: '0.01rem',
                        justifyContent: 'flex-start',
                        maxWidth: '25px'
                    }}>
                        <Tooltip arrow placement="left" title="Редактировать">
                            <Button size="small" sx={{minWidth: 'auto', marginLeft: 'auto'}} color="pencil"
                                    onClick={() => handleUpdateModel(row)}>
                                <Edit sx={{minWidth: 'auto', marginLeft: 'auto', fontSize: 20}}/>
                            </Button>
                        </Tooltip>
                        <Tooltip arrow placement="right" title="Удалить">
                            <Button size="small" sx={{minWidth: 'auto', marginLeft: 'auto'}} color="error"
                                    onClick={() => handleDeleteRow(row)}>
                                <Delete sx={{minWidth: 'auto', marginLeft: 'auto', fontSize: 20}}/>
                            </Button>
                        </Tooltip>
                    </Box>
                )}
                renderTopToolbarCustomActions={({table}) => {
                    const chooseSignJob = () => {
                        const selectedRows = table.getSelectedRowModel().flatRows;
                        const selectedIds = selectedRows.map((row) => row.getValue('id'));
                        const selectedIndexRows = selectedRows.map((row) => row.index);
                        setSelectedIds(selectedIds);
                        setRowIndexSelection(selectedIndexRows);
                        setShowConfirmAddSignJob(true)
                    };

                    return (
                        <div>
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: '0.5rem',
                                    paddingLeft: '0.5rem',
                                    paddingTop: '0.5rem',
                                    paddingBottom: '0.2rem',
                                    flexWrap: 'wrap',
                                }}
                            >
                                {isRedirectSettings && <Button
                                    size="small"
                                    color="secondary"
                                    onClick={redirectSettings}
                                    variant="contained"
                                >
                                    Вернуться в настройки
                                </Button>}
                                {isChooseSignJob && <Button
                                    size="small"
                                    color="secondary"
                                    onClick={chooseSignJob}
                                    variant="contained"
                                    disabled={table.getSelectedRowModel().rows.length === 0}
                                >
                                    Установить
                                </Button>}
                                {uploadSignJob && <UploadSignJobFileForm
                                    label={'Загрузить операции'}
                                    change={change}
                                    setChange={setChange}
                                />}
                            </Box>
                        </div>
                    );
                }}
            />
            <ModalConfirm
                title={"Вы действительно хотите добавить работы?"}
                modalOpen={showConfirmAddSignJob}
                handleClose={handleCloseShowConfirmAddSignJob}
                handleSubmit={handleSubmitAddSign}
                action={'Установить'}
            />
        </div>
    );
};

export default SignJobTable;